<div class="eula">
  <div class="eula-header">
    <h2>End User License Agreement (EULA)</h2>
  </div>
  <div class="eula-content" [innerHTML]="trustedHtmlContent"></div>
  <mat-divider></mat-divider>
  <div class="eula-footer">
    <div class="eula-footer-acknowledgements">
      <mat-checkbox
        type="checkbox"
        (change)="isAcceptChanged($event)"
        class="eula-footer-agreement-checkbox"
        >I Accept and Continue.</mat-checkbox
      >
    </div>

    <div class="eula-footer-actions">
      <button
        mat-raised-button
        color="secondary"
        class="eula-footer-button"
        (click)="onDecline()"
      >
        Decline
      </button>
      <button
        mat-raised-button
        color="primary"
        class="eula-footer-button"
        (click)="onSubmit()"
        [disabled]="!acceptChecked"
      >
        Submit
      </button>
    </div>
  </div>
</div>
